<script setup lang="ts">
import numeral from 'numeral'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { formatCost } from '@/stay-displayer/utils'

const { t } = useI18n()

const props = defineProps({
  cost: {
    type: Number,
    default: null
  },
  moneyGap: {
    type: Number,
    default: 0
  },
  gmt: {
    type: String,
    default: null
  }
})

const formattedCost = computed(() => formatCost(props.cost))
const hasRevaluation = computed(() => props.moneyGap !== 0)
const formattedOriginalCost = computed(() => formatCost(props.cost - props.moneyGap))
const formattedMoneyGap = computed(() => `${numeral(props.moneyGap).format('+ 0,0').replace(/,/g, ' ')} €`)
const isGmtSet = computed(() => props.gmt !== null && props.gmt !== '')
const gmtContent = computed(() => isGmtSet.value ? `${t('stayDisplayer.grouping.gmt')} : ${props.gmt}` : '')
</script>

<template>
  <div class="grouping-cost-block">
    <span
      id="grouping-amount"
      v-tooltip.left="gmtContent"
      class="grouping-cost"
      :class="{ 'grouping-cost-context': isGmtSet }"
    >{{ formattedCost }}</span>
    <div
      v-if="hasRevaluation"
      class="grouping-cost__revaluation"
    >
      <span
        id="revaluation-amount"
        class="grouping-cost__original"
      >{{ formattedOriginalCost }}</span>
      <span
        id="revaluation-delta"
        class="grouping-cost__delta"
        :class="moneyGap > 0 ? 'grouping-positive-revaluation' : 'grouping-negative-revaluation'"
      >({{ formattedMoneyGap }})</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.grouping-cost-block {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.grouping-cost {
  font-weight: 700;
  font-size: 23px;
  line-height: 1;

  &-context {
    cursor: context-menu;
  }
}

.grouping-cost__revaluation {
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.grouping-cost__delta {
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
}

.grouping-cost__original {
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  text-decoration: line-through;
}
</style>
